import axiosInstance from "../plugins/axios";

import Vue from "vue";

export function appService() {

  const paymentHistoryScope = async (data) => {
    let query = ``;
    if(data){
      query += `?`;
      if(data.scope) query += `&scope=${data.scope}`;
      if(data.start) query += `&start=${data.start}`;
      if(data.end) query += `&end=${data.end}`;
    // query = `?scope=${data.scope}&start=${data.start}&end=${data.end}`
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/payment-history-scope/${query}`,
    );
  };
  const questionHistory = async (data) => {
    let query = ``;
    if(data){
      query += `?`;
      if(data.scope) query += `&scope=${data.scope}`;
      if(data.start) query += `&start=${data.start}`;
      if(data.end) query += `&end=${data.end}`;
    // query = `?scope=${data.scope}&start=${data.start}&end=${data.end}`
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/question-history/${query}`,
    );
  };
  const consultantHistory = async (data) => {
    let query = ``;
    if(data){
      query += `?count=4`;
      if(data.page) query += `&page=${data.page}`;
      if(data.scope) query += `&scope=${data.scope}`;
      if(data.start) query += `&start=${data.start}`;
      if(data.end) query += `&end=${data.end}`;
    // query = `?scope=${data.scope}&start=${data.start}&end=${data.end}`
    }else{
      query += `?page=1&count=4`;
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/consultant-history/${query}`,
    );
  };
  const consultantQuestionHistory = async (data) => {
    let query = ``;
    if(data){
      query += `?count=4`;
      if(data.page) query += `&page=${data.page}`;
      if(data.scope) query += `&scope=${data.scope}`;
      if(data.start) query += `&start=${data.start}`;
      if(data.end) query += `&end=${data.end}`;
      // query = `?scope=${data.scope}&start=${data.start}&end=${data.end}`
    }else{
      query += `?page=1&count=4`;
    }
    return await axiosInstance.get(
      `${process.env.VUE_APP_BASE_URL_ADMIN}/consultant-questions-history/${query}`,
    );
  };

  return {
    paymentHistoryScope,
    questionHistory,
    consultantHistory,
    consultantQuestionHistory
  };
}
